<template>
  <div class="slider-wrapper">

    <!-- Left slide bar -->
    <transition name="show-by-index">
      <div v-show="(selectedSlide > 0)" class="direction-btn left">
        <div class="icon-holder" v-touch:tap="slideTo('right')">
          <div class="icon white-arrow"></div>
        </div>
      </div>
    </transition>

    <!-- Slider -->
    <div class="sm-slider-wrapper">
      <flickity
        ref="flickity"
        :options="flickityOptions"
      >
        <div v-for="(slide, i) in slides" :key="i"
             :class="['carousel-cell', (slide.color), (slide.color_hover)]"
        >
          <div :class="['cell-header', {'top-text': (slide.txt_t_header !== undefined)}]">
            <h3 v-if="(slide.txt_t_header !== undefined)" class="abs-header" v-html="$lang[slide.txt_t_header]"></h3>
            <div v-if="(slide.double_name)" class="icon-and-txt">
              <p><span class="border-nr">{{(i + 1)}}</span></p> <h3>{{$lang[slide.double_name]}}</h3>
            </div>
            <div v-if="(slide.icon !== undefined)" :class="['icon', (slide.icon), {'icon-header': (slide.icon_class !== undefined)}, (slide.icon_class)]"></div>
            <h3
              :class="[{'abs-h-72': (specialClass !== undefined && specialClass.absHClass)}]"
              v-if="(slide.txt_name !== undefined)"
              v-html="$lang[slide.txt_name]"
            ></h3>
          </div>
          <div class="cell-body">
            <div v-if="(slide.txt !== undefined)" v-html="$lang[slide.txt]"></div>
            <h3 v-if="(slide.txt_header !== undefined)" v-html="$lang[slide.txt_header]"></h3>
            <p v-if="(slide.txt_body !== undefined)" v-html="$lang[slide.txt_body]"></p>
            <div v-if="(slide.modal !== undefined)" class="btn arrow empty" v-touch:tap="popModal(slide.modal)"></div>
          </div>
        </div>
      </flickity>
    </div>

    <!-- Right slide bar -->
    <transition name="show-by-index">
      <div v-show="(selectedSlide < (slides.length - 1))" class="direction-btn right">
        <div class="icon-holder" v-touch:tap="slideTo('left')">
          <div class="icon white-arrow"></div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'small-slider',
  data () {
    return {
      flickityOptions: {
        initialIndex: 0,
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        dragThreshold: 40,
        contain: true
      },
      selectedSlide: 0
    }
  },
  props: {
    context: {
      type: String
    },
    slides: {
      type: Array,
      required: true
    },
    specialClass: {
      type: Object,
      required: false
    }
  },
  mounted () {
    let self = this
    this.$refs.flickity.on('dragEnd', function () {
      self.selectedSlide = self.$refs.flickity.selectedIndex()
    })
  },
  methods: {
    slideTo (side) {
      let self = this
      return () => {
        self.onSlideTo(side)
      }
    },
    onSlideTo (side) {
      if (side === 'right') {
        this.$refs.flickity.previous()
        this.selectedSlide = this.$refs.flickity.selectedIndex()
      } else if (side === 'left') {
        this.$refs.flickity.next()
        this.selectedSlide = this.$refs.flickity.selectedIndex()
      }
    },
    popModal (modal) {
      let self = this
      return () => {
        self.onPopModal(modal)
      }
    },
    onPopModal (modal) {
      this.$bus.$emit(this.context + 'SHOW.POPUP', {modal: modal})
    }
  },
  components: {
    'flickity': Flickity
  }
}
</script>



// WEBPACK FOOTER //
// src/components/small-slider/index.vue